import {Component, ContentChild, TemplateRef} from "@angular/core";

@Component({
    selector: "fui-panel",
    styleUrls: ["./panel.component.scss"],
    templateUrl: "./panel.component.html",
    standalone: false
})
export class FUIPanelComponent {
    @ContentChild("panelcontent", {read: TemplateRef}) public panelContent: TemplateRef<HTMLTemplateElement>;

    constructor() {

    }
}
